module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACYAAAAYCAYAAACWTY9zAAAAAXNSR0IArs4c6QAAAGFJREFUSA1jPKug8Z9hEAKmQegmsJNGHUZqzIyG2GiIkRoCpKofTWPDJsRYxJMTjpHqG3qoZ/wPBPSwiFQ7RhP/aIiRGgKkqh9NY6MhRmoIkKp+NI2RGmIsQA3+pGqih3oAkB8IMjLbp24AAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/Indonesia.png
// module id = 475
// module chunks = 7